import { queryOrThrow } from "@rootreeweb/js-lib";

import { hideLevels } from "./inititalState.js";
import { handleButtonText } from "./listeners.js";
import { childrenShowingClass, isParentClass } from "./selectorHelpers.js";
import { showRow } from "./visibility.js";

let tableElement: HTMLTableElement;
let tbodyElement: HTMLTableSectionElement;
/**
 * Add global functionality to the table. Ex. show-all
 *
 * @param _tableElement The pages' table element.
 */
export function addGlobalControls(_tableElement: HTMLTableElement): void {
	tableElement = _tableElement;
	tbodyElement = queryOrThrow(tableElement, "tbody");
	removeTableStripes();
	tableElement.before(createGlobalControls());
}
/** Remove the stripes from the table since they look weird with hidden rows. */
function removeTableStripes() {
	tableElement.classList.remove("striped");
}

/**
 * Creates a div with the expand all, etc. controls.
 *
 * @returns The div element.
 */
function createGlobalControls(): HTMLDivElement {
	const div = document.createElement("div");
	div.appendChild(createButton("Expand All", expandAll, []));
	div.appendChild(createButton("Collapse All", collapseAll, []));
	return div;
}

/**
 * Creates a button on the bage.
 *
 * @param label The button text.
 * @param onClick The click event handler.
 * @param additionalClasses Any additional css classes to add to the button.
 * @returns The button element.
 */
function createButton(
	label: string,
	onClick: () => void,
	additionalClasses?: string[],
): HTMLButtonElement {
	const button = document.createElement("button");
	button.classList.add("button");
	if (additionalClasses) {
		button.classList.add(...additionalClasses);
	}
	button.textContent = label;
	button.type = "button";
	button.addEventListener("click", () => onClick());
	return button;
}

/** Expand all page trees. */
function expandAll(): void {
	const rows = tableElement.querySelectorAll("tr");
	rows.forEach((row) => {
		if (row.classList.contains(isParentClass)) {
			row.classList.add(childrenShowingClass);
			handleButtonText(row);
		}
		showRow(row);
	});
}

/** Collapse all page trees */
function collapseAll(): void {
	hideLevels(tbodyElement);
	const rows = tableElement.querySelectorAll("tr");
	rows.forEach((row) => {
		row.classList.remove(childrenShowingClass);
		handleButtonText(row);
	});
}
